import { Modal, Button } from '@mui/material';
import { Footer, ModalBox, ModalH2 } from '../../../Styles/ModalStyle';
import FormBuilder from '../../../../shared/components/FormBuilder';
import { ClienteRelatorioSchema } from '../../../../schemas/ClienteRelatorioSchema';
import useModalRelatorioCliente from '../../../../hooks/useModalRelatorioCliente';
import { FormikProps } from 'formik';
import { useRef } from 'react';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    values: any;
    onSuccess: () => void;
}

const ModalRelatorioCliente = ({ open, onClose, values, onSuccess }: ModalProps) => {

    const formRef = useRef<FormikProps<any>>(null);

    const {
        cliente,
        produto,
        fetchClientes,
        fetchProdutos,
        handleSubmit,
    } = useModalRelatorioCliente({ onClose, onSuccess });

    const optionsPeriodo = [
        { label: '30 Dias', value: 30 },
        { label: '60 Dias', value: 60 },
        { label: '90 Dias', value: 90 },
    ];

    const fields = [
        { name: 'cliente_id', type: 'number', label: 'Código', col: 12},
        { name: 'cliente_nome', type: 'autocomplete', label: 'Cliente', col: 12, options: cliente, optionKey: "cli_id", optionLabel: 'cli_nome', required: true, onInput: (_, v: string) => fetchClientes(v) },
        { name: 'prod_id', type: 'autocomplete', label: 'Produto', col: 12, options: produto, optionKey: "prod_id", optionLabel: 'prod_descricao', required: true, onInput: (_, v: string) => fetchProdutos(v) },
        { name: 'periodo', type: 'select', label: 'Período', col: 12, options: optionsPeriodo },
    ]

    const getInitialValues = () => {
        const item = values?.selectedItem?.Item || values?.selectedItem;

        return {
            cliente_id: item.cliente_id || '',
            cliente_nome: item.cliente_nome || '',
            prod_id: item.prod_id || '',
            periodo: 30
        };
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
            <ModalBox>
                <ModalH2>Relatório Cliente</ModalH2>
                <FormBuilder fields={fields} initialValues={getInitialValues()} onSubmit={handleSubmit} gap='gap-3' innerRef={formRef} validationSchema={ClienteRelatorioSchema} />
                <Footer>
                    <Button onClick={onClose} color='error'>
                        Fechar
                    </Button>
                    <Button type='button' variant='contained' color='primary' onClick={() => formRef.current?.submitForm()}>
                        Confirmar
                    </Button>
                </Footer>
            </ModalBox>
        </Modal>
    );
};

export default ModalRelatorioCliente;